import './index_mWeb.css';
import {
  convertToDollars,
  isMatchInScheduled,
  maskUserName,
  RoundedOffAmount
} from '../../../utilities/helper';
import { View, Text, GadgetLeague } from '../../../component';
import I18n from '../../../utilities/locale';
import Constants from '../../../constants';
import React from 'react';

interface Props {
  item: any;
  userId: number;
  completed?: boolean;
  onPress: any;
  onPressSwitchTeam: any;
  rank?: number;
  tabType?: string;
  matchStatus?: any;
  matchVerifiedStatus: boolean;
  index?: number;
  gameState?: any;
  matchDelayed?: boolean;
  contestTeamsLength?: any;
  isGadgetLeague?: boolean;
  description?: any;
  gameType?: any;
  wonAmount?: any;
  idx: any;
}

const ContestDetailsPlayerRowMWeb = ({
  item,
  userId,
  onPress,
  onPressSwitchTeam,
  completed,
  tabType,
  matchStatus,
  matchVerifiedStatus,
  gameState = 0,
  matchDelayed = false,
  contestTeamsLength = 0,
  isGadgetLeague = false,
  description = '',
  gameType,
  wonAmount,
  idx = 0
}: Props) => {
  const {
    userId: user_id,
    rank = 1,
    winningZone = false,
    teamNumber = 0,
    firstname: firstName = '',
    lastname: lastName = '',
    username: userName = '',
    score = 0,
    verifiedScore,
    isShow = true
  } = item;

  const newUserName = maskUserName(firstName, lastName, userName);
  const newScore = verifiedScore ? verifiedScore : score;

  const winningAmount = RoundedOffAmount(wonAmount);

  const winnerTextColor = {
    color: '#fff'
  };
  const teamNumberColor = {
    color: '#858999'
  };

  const contestScoreColor = {
    color: '#fff'
  };

  const winningZoneTextColor = {
    color: '#FFDB53'
  };

  const isMatchScheduled = isMatchInScheduled({
    matchStatus,
    gameState,
    matchDelayed
  });

  const _onPressCard = (event: any) => {
    event.stopPropagation();
    onPress({ ...item, teamName: newUserName });
  };

  const _onPressSwitchTeam = (event: any) => {
    event.stopPropagation();
    onPressSwitchTeam(item);
  };

  if (!isShow) return null;
  return (
    <View
      onPress={_onPressCard}
      className={'contest-details-user-container_mWeb'}
      style={{
        backgroundColor: idx % 2 === 0 ? '#1e242b' : 'transparent',
        borderLeftColor: '#FFDB53',
        borderLeftWidth: userId === user_id ? '3px' : '0px'
      }}>
      <View className={'contest-details-user-header-wrapper_mWeb'}>
        <View className={'contest-details-user-header_mWeb'} style={{ flex: 2 }}>
          <View className={'contest-details-user-team-name-number-wrapper_mWeb'}>
            <View>
              <View style={{ flexDirection: 'row' }}>
                <Text className={'contest-details-user-winner-text_mWeb'} style={winnerTextColor}>
                  {userName}
                </Text>
                {gameType != 'YES_NO' && (
                  <Text
                    className={'contest-details-user-team-number_mWeb'}
                    style={teamNumberColor}>{` T${teamNumber}`}</Text>
                )}
              </View>
              {((tabType === 'LIVE' && winningZone) ||
                (tabType === 'RESULT' && winningZone && !matchVerifiedStatus)) && (
                <Text
                  className={'contest-details-user-winning-zone-text_mWeb'}
                  style={winningZoneTextColor}>
                  {I18n.t('InWinningZone')}
                </Text>
              )}
            </View>
          </View>
        </View>
        {(tabType === 'LIVE' || tabType === 'RESULT') && (
          <View className={'contest-details-user-rank-points_mWeb'} style={{ flex: 1 }}>
            <Text className={'contest-details-user-contest-score_mWeb'} style={contestScoreColor}>
              {rank}
            </Text>
          </View>
        )}
        {(tabType === 'LIVE' || tabType === 'RESULT') && (
          <View className={'contest-details-user-rank-points_mWeb'} style={{ flex: 1 }}>
            <Text className={'contest-details-user-contest-score_mWeb'} style={contestScoreColor}>
              {newScore}
            </Text>
          </View>
        )}
        {tabType === 'RESULT' && matchVerifiedStatus && (
          <View
            className={'contest-details-user-rank-points_mWeb'}
            style={{ flex: 2, justifyContent: 'center' }}>
            {isGadgetLeague && winningZone ? (
              <GadgetLeague
                titleClassName="contest-details-gadget-prize-title_mWeb"
                titleStyle={contestScoreColor}
                imageStyle={{
                  width: '30px',
                  height: '30px'
                }}
                description={description}
              />
            ) : (
              <>
                <Text
                  className={'contest-details-user-contest-score_mWeb'}
                  style={contestScoreColor}>
                  {`${convertToDollars(winningAmount)}`}&nbsp;
                </Text>
              </>
            )}
          </View>
        )}
        {userId === user_id &&
          !completed &&
          isMatchScheduled &&
          contestTeamsLength < 11 &&
          gameType !== 'YES_NO' && (
            <View
              className={'contest-details-user-team-switch-container_mWeb'}
              onPress={_onPressSwitchTeam}>
              <Constants.Svgs.SwitchTeam width={'35px'} />
            </View>
          )}
      </View>
    </View>
  );
};
export default React.memo(ContestDetailsPlayerRowMWeb);
